export default "/images/d302cddfeb121b0dd033414730e0485a.avif";